import findRowComponent from "features/Letterbooks/utils/views/findRowComponent";
import {
  LetterbookSettingType,
  LetterbooksPageProps,
} from "features/Letterbooks/types";
import LetterbookTableCollection from "./TableCollection/TableCollection";
import LetterbookCardCollection from "./CardCollection/CardCollection";
import LetterbookShelfCollection from "./ShelfCollection/ShelfCollection";
import { usePage } from "@inertiajs/react";

const CollectionComponents = {
  card: LetterbookCardCollection,
  table: LetterbookTableCollection,
  shelf: LetterbookShelfCollection,
};

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function LetterbooksCollection({
  settings,
}: Readonly<LetterbookOptions>) {
  const { letterbooks } = usePage<LetterbooksPageProps>().props;
  const CollectionView = CollectionComponents[settings.view];
  const RowComponent = findRowComponent(settings);

  return (
    <CollectionView
      letterbooks={letterbooks.letterbooks}
      settings={settings}
      RowComponent={RowComponent}
    />
  );
}
